
export const EARLY_BIRD = new Date('2026/05/31'); // THIS DEFAULTS TO 00:00:00. Make sure to set the time too OR set it to the next day
export const DEFAULT_SESSION_GROUP = 'NO_GROUP';
export const ASMHomePage = "https://www.bct2026.org/";

//package id constants
export const TRAINEE_AND_EARLY_CAREER_EVENT_PACKAGE_ONLY = 17;

// Session ID constants
export const CAP_MEETING_SESSION_ID = 1;
export const ABSTRACT_VIEWING_SESSION_ID = 7;
export const FACULTY_DINNER_SESSION_ID = 9;
export const CONFERENCE_DINNER_SESSION_ID = 15;

export const REGISTRATION_FORM_DEFINITION_ID = 1;
export const EARLY_BIRD_FORM_DEFINITION_ID = 10;